/**
 * Brazilian Portuguese strings for the `home` namespace — the landing hero and the
 * upcoming-sections teasers.
 *
 * Keys are in English (repo convention); values are the pt-BR copy shown to users.
 * `<i>` tags are mapped to elements by react-i18next's <Trans>.
 */
export const home = {
  kicker: 'O códice da comunidade brasileira',
  title: 'RuneLedger',
  promise:
    'Perfis e habilidades de jogadores e os streamers brasileiros de <i>RuneScape 3</i> — num só códice, aberto e feito pela comunidade.',
  ctaAbout: 'Conhecer o projeto',
  ctaDiscord: 'Discord',
  soon: 'Em breve',
  live: 'No ar',
  // Decorative floating runes — not copy, but centralized so pages have zero literals.
  decorRunes: {
    left: 'ᛟ',
    right: 'ᚨ',
  },
  upcoming: {
    profiles: {
      title: 'Perfis',
      text: 'Skills e XP de qualquer jogador, com snapshots de evolução.',
    },
    streamers: {
      title: 'Streamers',
      text: 'Quem está ao vivo em Gielinor, falando português.',
    },
  },
}
